import 'animate.css';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { styled } from 'troyfe';
import { CloseOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import AnimationModalStyle from './style';

const Block = styled.div`
  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /* z-index: 1000; */
    z-index: ${(props) => `${props?.ZIndex ? props?.ZIndex : 1000}`};
    height: 100%;
    background-color: ${(props) => (!props.mask ? '#00000073' : '')};
  }
`;
const AnimationModal = (props) => {
  const {
    title,
    closeCallback,
    confirmCallback,
    isFooter = true,
    width,
    mask,
    scroll,
    ZIndex,
  } = props;
  const [coordinate, setCoordinate] = useState({
    styleTop: 100,
    styleLeft: 0,
  });

  useEffect(() => {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    return () => {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    };
  }, []);

  const inWindow = (left, top, startPosX, startPosY) => {
    const H = document.body.clientHeight;
    const W = document.body.clientWidth;
    if (
      (left < 20 && startPosX > left) ||
      (left > W - 20 && startPosX < left) ||
      (top < 20 && startPosY > top) ||
      (top > H - 20 && startPosY < top)
    ) {
      document.body.onmousemove = null;
      document.body.onmouseup = null;
      return false;
    }
    return true;
  };

  const onMouseDown = (e) => {
    e.preventDefault(); // 记录初始移动的鼠标位置
    const startPosX = e.clientX;
    const startPosY = e.clientY;
    const { styleLeft, styleTop } = coordinate; // 添加鼠标移动事件
    document.body.onmousemove = (e) => {
      const left = e.clientX - startPosX + styleLeft;
      const top = e.clientY - startPosY + styleTop;
      if (inWindow(e.clientX, e.clientY, startPosX, startPosY)) {
        setCoordinate({
          styleLeft: left,
          styleTop: top,
        });
      }
    }; // 鼠标放开时去掉移动事件
    document.body.onmouseup = function () {
      document.body.onmousemove = null;
    };
  };

  const closeFn = () => {
    closeCallback(false);
  };
  const confirmFn = () => {
    confirmCallback(true);
  };
  const style = { left: coordinate.styleLeft, top: coordinate.styleTop };

  return (
    <Block mask={mask} scroll={scroll} ZIndex={ZIndex}>
      <div className="mask" />
      <ReactCSSTransitionGroup
        transitionEnter
        transitionLeave
        transitionEnterTimeout={900}
        transitionLeaveTimeout={1500}
        transitionName="animated"
      >
        <AnimationModalStyle
          className="animate__animated animate__slideInDown"
          width={width}
          scroll={scroll}
          ZIndex={ZIndex}
        >
          <div className="wrap" style={style}>
            {title && (
              <div
                className="animate-modal-header"
                style={{ cursor: 'move' }}
                onMouseDown={onMouseDown}
              >
                <div className="animate-modal-title" id="rcDialogTitle0">
                  {title}&nbsp;
                </div>
                <div
                  type="button"
                  className="ant-modal-close"
                  onClick={() => {
                    closeCallback();
                  }}
                >
                  <CloseOutlined />
                </div>
              </div>
            )}
            <div
              className="animate-modal-content"
              style={{
                borderRadius: title ? '0px 0px 8px 8px ' : '8px 8px 8px 8px',
              }}
            >
              {props.children}
            </div>
            {isFooter && (
              <div className="footerModal">
                {isFooter === true || isFooter.indexOf('cancel') !== -1 ? (
                  <div className="close" onClick={closeFn}>
                    取消
                  </div>
                ) : null}

                {isFooter === true || isFooter.indexOf('determine') !== -1 ? (
                  <div className="confirm" onClick={confirmFn}>
                    确定
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </AnimationModalStyle>
      </ReactCSSTransitionGroup>
    </Block>
  );
};

export default AnimationModal;
